import { render } from "./roomGuestsB2b.vue?vue&type=template&id=0cdb5d06&scoped=true"
import script from "./roomGuestsB2b.vue?vue&type=script&lang=js"
export * from "./roomGuestsB2b.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"
import "./roomGuestsB2b.vue?vue&type=style&index=1&id=0cdb5d06&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cdb5d06"]])

export default __exports__